<script lang="ts">
import isEqual from 'lodash/isEqual';
import { computed, defineComponent, inject, onBeforeUnmount, reactive, ref, toRefs } from 'vue';
import type { Field } from './symbols';
import { registerSymbol, getFieldDefaultValueSymbol } from './symbols';

export default defineComponent({
  name: 'FilterStateFieldInner',
  props: {
    defaultValue: {
      type: null,
      default: undefined
    },
    invisible: Boolean,
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { defaultValue, name, invisible } = toRefs(props);
    const getFieldDefaultValue = inject(getFieldDefaultValueSymbol);
    const register = inject(registerSymbol);

    const computedDefaultValue = computed(
      () => getFieldDefaultValue(name.value) ?? defaultValue.value
    );
    const value = ref(computedDefaultValue.value);

    const onChange = (newValue) => {
      if (isEqual(value.value, newValue)) {
        return;
      }

      value.value = newValue;
    };

    const field: Field = reactive({
      getValue: () => value.value,
      getIsInvisible: () => invisible.value
    });

    const unregister = register(name.value, field);
    onBeforeUnmount(() => {
      unregister();
    });

    return {
      onChange,
      value
    };
  },
  render() {
    if (this.invisible) {
      return null;
    }
    return this.$slots.default({
      name: this.name,
      value: this.value,
      onChange: this.onChange
    });
  }
});
</script>

<i18n lang="json">{}</i18n>
